import React from 'react';
import Signature from './Signature';
import './Signatures.scss';

const Signatures = ({ socios = [] }) => {
  const twoColumns = socios.length >= 6;

  const getFontSize = () => {
    if (socios.length >= 9) return 'sociosLength9';
    if (socios.length === 8) return 'sociosLength8';
    if (socios.length >= 6) return 'sociosLength6';
    if (socios.length === 5) return 'sociosLength5';
    return '';
  };

  if (!socios.length) {
    return <></>;
  }

  return (
    <div
      className={`row hola ${getFontSize()}`}
      style={{
        ...(twoColumns ? { rowGap: '1em' } : { gap: '1em' }),
      }}
    >
      {socios?.map((socio, index) => (
        <div className={`${twoColumns ? 'col-6' : 'col-12'}`} key={index}>
          <Signature socio={socio} />
        </div>
      ))}
    </div>
  );
};

export default Signatures;

const styles = {
  signatureContainer: {
    display: 'flex',
    gap: '2em',
  },
};
